(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FranchiseDataTransfer',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// only allow one checkbox to be checked
		$(".transfer-type-selection").on('click', function toggleSection(e)
		{
			var $self      = $(this),
				checked    = $self.prop('checked'),
				id         = $self.attr('id'),
				val        = $self.val(),
				split      = val.split('-'),
				show_class = split[0] + '-fields',
				customs    = ['split-1', 'associate-1'];

			// toggle custom fields where appropriate
			$.each( customs, function loopCustoms( index, custom_value ) {
				if (custom_value === val) {
					$('.' + custom_value).removeClass('hidden');
					return false;
				}
				$('.' + custom_value).addClass('hidden');
			});

			if (checked) {
				$('.transfer-type-selection').each(function showFields() {
					if ($(this).attr('id') !== id) {
						$(this).prop('checked', false);
					}
				});

				// show terms and conditions checkbox, because at least one transfer type is checked
				$('.terms-box').removeClass('hidden');
			} else {
				// hide terms and conditions checkbox, because no transfer type is checked
				$('.terms-box').addClass('hidden');
			}

			// show fields based on the transfer type
			$('.transfer-type').each(function showFields() {
				if (($(this).hasClass(show_class)) && (checked)) {
					$(this).removeClass('hidden');

				} else {
					$(this).addClass('hidden');
				}
			});
		});

		$("#franchisedatatransfer-merge_own_destination").on('change', function toggleSection(e)
		{
			var $self     = $(this),
			    $selected = $self.children("option:selected");

			if ($selected.length > 0) {
				$('#copy-client-list').removeClass('hidden');
			} else {
				$('#copy-client-list').addClass('hidden');
				$('#franchisedatatransfer-merge_copy_client_list').val('');
			}
		});

		// SET-95: SCOPED TO .transfer-type RATHER THAN BOOTSTRAP'S .box. Both markups put the two
		// classes on the same element, so this finds the identical container on the legacy screen -
		// but .box is page-chrome the settings modal does not use, and keying behaviour to it meant
		// this handler silently found nothing there.
		$(".grant-access").on('change', function toggleSection(e)
		{
			var $self         = $(this),
			    $agents_div   = $self.closest('.transfer-type').find('.access-agents'),
			    $agents_input = $agents_div.find('.grant-access-agents');

			if ($self.val() === '3') {
				$agents_div.removeClass('hidden');
			} else {
				$agents_div.addClass('hidden');
				// $self.closest('.bs-deselect-all').trigger('click');
			}

			$agents_input.val('');
		});
	};
}(jQuery, window.Adzuki || {}));
